module.exports = __webpack_public_path__ + "static/people_pop10-7036e4af01765a24b2490300fd9ae010.png";